module.exports = __webpack_public_path__ + "static/media/cheque.3f2cb7d5.png";